import { Component, Input, OnInit } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'custom-skeleton',
  templateUrl: './custom-skeleton.component.html',
  styleUrls: ['./custom-skeleton.component.scss'],
})
export class CustomSkeletonComponent {
  @Input()
  public lines: number;
  @Input()
  public class: string;

  constructor() {
    this.lines = 1;
  }
}
